export const SET_NEWSHIPMENTS = 'shipments/SET_NEWSHIPMENTS'
export const SET_MYSHIPMENTS = 'shipments/SET_MYSHIPMENTS'
export const SET_OFFERS = 'shipments/SET_OFFERS'
export const RESET_SHIPMENTS = 'shipments/RESET_SHIPMENTS'
